export const config = {
  apiURL: import.meta.env.VITE_API_URL,
  pixelsPerSecond: 10,
  defaultDuration: 5000, // milisecond
};
